<template>
    <div class="c-cekajici-resene__karta-inside"  >
        <div class="c-karta__event-id" v-bind:class="{ 'c-karta__event-id--assigned' : getPropertyValue(item, 'isAssigned') }" >{{getPropertyValue(item, 'cisloVyzvy')}}</div>
        <div class="c-karta clickable"
             v-bind:class="{ 'c-karta--assigned' : getPropertyValue(item, 'isAssigned') }"
             @click="openEventModal"
             @contextmenu.prevent="$refs.menu.open">
            <div class="c-karta__num c-karta__num" v-bind:class="getUrgencyColor(getPropertyValue(item, 'nalehavost'))">{{getPropertyValue(item, 'nalehavost')}}</div>
            <div class="c-karta__row">
                <div class="c-karta__item c-karta__item--cas">
                    <span><small>{{timeLeft}}</small></span><br>
                    <small>{{getPropertyValue(item, 'casVzniku')}}</small>
                </div>
                <div class="c-karta__item--klasifikace" v-bind:title="translate('Page1.' + getPropertyValue(item, 'klasifikace'), getPropertyValue(item, 'klasifikace')) + '\n' + (getPropertyValue(item, 'klasifikacePoznamka') || '')">
                    {{translate('Page1.' + getPropertyValue(item, 'klasifikace'), getPropertyValue(item, 'klasifikace'))}}
                    <br>
                    <div style="text-transform: none;">{{getPropertyValue(item, 'klasifikacePoznamka')}}</div>
                </div>
                <div class="c-karta__half-row c-karta__item--posadka">
                    <div class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in LZSs" v-bind:class="itm.cssClass">
                        {{translate('Page1.' + itm.value, itm.value)}}
                    </div>
                    <div class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in RVs" v-bind:class="itm.cssClass">
                        {{translate('Page1.' + itm.value, itm.value) }}
                    </div>
                    <div class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in UMs" v-bind:class="itm.cssClass">
                        {{translate('Page1.' + itm.value, itm.value)}}
                    </div>
                    <div class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in IPs" v-bind:class="itm.cssClass">
                        {{translate('Page1.' + itm.value, itm.value)}}
                    </div>
                    <div class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in RZPs" v-bind:class="itm.cssClass">
                        {{translate('Page1.' + itm.value, itm.value)}}
                    </div>
                    <div class="c-karta__half-item c-karta__half-item--posadka" :key="itm.id" v-for="itm in KORs" v-bind:class="itm.cssClass">
                        {{translate('Page1.' + itm.value, itm.value)}}
                    </div>

                    <div v-if="getCrewCount().length > 10"
                         v-on:click.stop="openCrewListModal()"
                         class="c-karta__half-item c-karta__half-item--more">
                        <i class="glyphicon glyphicon-option-horizontal"></i>
                    </div>
                </div>
            </div>
            <div class="c-karta__row c-karta__row--adresa">
                <div class="c-karta__item--adresa" v-bind:title="(getPropertyValue(item, 'ulice') || '') /*+ ' ' + (getPropertyValue(item, 'cp') || '') + '/' + (getPropertyValue(item, 'co') || '') + ',' + (getPropertyValue(item, 'obec') || '')*/ + '\n' + (getPropertyValue(item, 'adresaPoznamka') || '')">
                    {{getPropertyValue(item, 'ulice')}} <!--{{getPropertyValue(item, 'cp')}}/{{getPropertyValue(item, 'co')}}, {{getPropertyValue(item, 'obec')}}--></div>
            </div>
            <div class="c-karta__row">
                <div class="c-karta__item--jmeno" v-bind:title="getPropertyValue(item, 'pacientJmeno')">{{getPropertyValue(item, 'pacientJmeno')}}</div>
                <div class="c-karta__item--rok">{{getPropertyValue(item, 'rokNarozeni')}}</div>
                <div class="c-karta__half-row">
                    <table class="c-karta__table">
                        <tbody>
                            <tr>
                                <td>{{translate('Page1.text13')}}</td>
                                <td>{{translate('Page1.text14')}}</td>
                                <td>{{translate('Page1.text15')}}</td>
                            </tr>
                            <tr>
                                <td>{{translate('Page1.text16')}}</td>
                                <td>{{translate('Page1.text17')}}</td>
                                <td>{{translate('Page1.text18')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <vue-context  :lazy="true" ref="menu" :close-on-click="closeOnClick" :close-on-scroll="closeOnScroll">
            
            
            
            <li v-if="canOpenEventModal">
                <a href="#" @click.prevent="openEventModal()">{{translate('Page1.text24')}}</a>
            </li>
            
            <li v-if="canStornoEvent">
                <a href="#" @click.prevent="stornoEvent(item.entityId, crews)">{{translate('Page1.text23')}}</a>
            </li>
            
            <li v-if="getPropertyValue(item, 'isAssigned')">
                <a href="#" @click.prevent="archiveEvent(item.entityId, crews)">{{translate('Page1.text25')}}</a>
            </li>
            
            <li v-if="getPropertyValue(item, 'isArchived')">
                <a href="#" @click.prevent="assignedFromArchiveEvent(item.entityId)">{{translate('Page1.text29')}}</a>
            </li>

            <li v-if="canRevokeStornoEvent">
                <a href="#" @click.prevent="waitingEvent(item.entityId, 'storno')">{{translate('Page1.text30')}}</a>
            </li>

            <li v-if="canRevokeForwardEvent">
                <a href="#" @click.prevent="waitingEvent(item.entityId, 'forward')">{{translate('Page1.text31')}}</a>
            </li>

            <li v-if="canForwardEvent">
                <div>
                    <a>{{translate('Page1.text28')}}</a> <span class="glyphicon glyphicon-triangle-right" aria-hidden="true"></span>
                    <div class="v-context__wrap">
                        <ul class="v-context">
                            <li v-for="forwardEventType in forwardEventTypes" v-bind:key="forwardEventType.entityId">
                                <a href="#" @click.prevent="forwardEvent(item.entityId)">{{getPropertyValue(forwardEventType, 'name')}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>

            <li v-if="canAddHospital">
                <div>
                    <a>{{translate('Page1.text26')}}</a> <span class="glyphicon glyphicon-triangle-right" aria-hidden="true"></span>
                    <div class="v-context__wrap">
                        <ul class="v-context">
                            <li v-for="hospital in hospitals" v-bind:key="hospital.entityId">
                                <a class="c-context-a" href="#" @click.stop.prevent="addHospital(item.entityId, hospital.entityId)">
                                    {{getPropertyValue(hospital, 'name')}} <span class="glyphicon glyphicon-triangle-right" aria-hidden="true"></span>
                                     <div class="c-context-wrap c-context-wrap--2">
                                         <ul class="v-context v-context--2">
                                             <li v-for="department in getPropertyValue(hospital, 'oddeleni')" v-bind:key="department.entityId">
                                                 <a href="#" class="c-context-a" @click.stop.prevent="addHospital(item.entityId, hospital.entityId, department)">
                                                      {{department}}
                                                 </a>
                                             </li>
                                         </ul>
                                     </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            
            <li v-for="crew in crews" v-bind:key="crew.entityId">
                <a href="#" @click.prevent="recallCrew(item.entityId, crew.entityId)">{{translate('Page1.text22')}}{{getPropertyValue(crew, 'volaciZnak')}}</a>
            </li>

            <li v-if="canShowOnMap">
                <a href="#" @click.prevent="showOnMapEvent(item.entityId)">{{translate('Page1.text27')}}</a>
            </li>
        </vue-context>
    </div>
</template>

<script>

    import getPropertyValue from '@/mixins/getPropertyValue.js';
    import getCrewStatusColor from '@/mixins/getCrewStatusColor.js';
    import { VueContext } from 'vue-context';
    import { mapActions } from 'vuex';
    import moment from 'moment';
    

    export default {
        name: 'EventsCard',
        components: {
            VueContext,
        },
        data: function () {
            return {
                event: 'Událost',
                showEventEditModal: false,
                randomKey: 0,
                closeOnClick: false,
                closeOnScroll: true, //funguje pouze na scroll celé stránky
                patientIsServed: false
            }
        },
        methods: {
            getUrgencyColor (urgency) {
                switch (Number(urgency)) {
                    case 1 : return 'c-karta__num--red';
                    case 2 : return 'c-karta__num--yellow';
                    case 3 : return 'c-karta__num--green';
                    case 4 : return 'c-karta__num--grey';
                    default: ''
                }
            },
            getPropertyValue,
            getCrewStatusColor,
            openEventModal(){
                this.$emit('openEventModal', this.value);
                this.$refs.menu.close(); // zavření contextoveho okna
            },
            openCrewListModal(){
                this.$emit('openCrewListModal', this.item);
                this.$refs.menu.close(); // zavření contextoveho okna
            },
            async recallCrew (event, ambulance) {
                try {
                    await this.sendCommand({cmd: 'recallAmbulance', payload: {event, ambulance}});
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text23'));
                } catch(e) {
                    console.log('Posádka se neodvolala', e);
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text24'));
                }
                this.$refs.menu.close();
            },
            async showOnMapEvent(event) {

                if(localStorage){
                    localStorage.setItem('mapComponentZoomToEvent', null); //to force browser event, even if same event is selected
                    localStorage.setItem('mapComponentZoomToEvent', event);
                }

                this.$refs.menu.close();
            },
            async stornoEvent(event, crews) {
                const ambulances = crews.map(c => c.entityId);
                try {
                    await this.sendCommand({cmd: 'stornoEvent', payload: {event, ambulances}});
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text25'));
                } catch(e) {
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text26'));
                }
                this.$refs.menu.close();
            },
            async archiveEvent(event, crews) {
                const ambulances = crews.map(c => c.entityId);
                try {
                    const response = await this.sendCommand({cmd: 'archiveEvent', payload: {event, ambulances}});
                    if(!response.done){
                        this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text37'));
                    } else {
                        this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text27'));
                    }
                } catch(e) {
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text28'));
                }
                this.$refs.menu.close();
            },
            async waitingEvent(event, previousState) {
                try {
                    await this.sendCommand({cmd: 'waitingEvent', payload: {event, previousState}});
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text31'));
                } catch(e) {
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text32'));
                }
                this.$refs.menu.close();
            },
            async forwardEvent(event) {
                try {
                    await this.sendCommand({cmd: 'forwardEvent', payload: {event}});
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text33'));
                } catch(e) {
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text34'));
                }
                this.$refs.menu.close();
            },
            async assignedFromArchiveEvent(event) {
                try {
                    await this.sendCommand({cmd: 'assignedFromArchiveEvent', payload: {event}});
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text35'));
                } catch(e) {
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text36'));
                }
                this.$refs.menu.close();
            },

            async addHospital(event, hospital, ward) {
                try {
                    await this.sendCommand({cmd: 'addHospital', payload: {event, hospital, ward}});
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text29'));
                } catch(e) {
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text30'));
                }
                this.$refs.menu.close();
            },
            getCrewColor(crew){
                if(crew) {
                    const status = this.getPropertyValue(crew, 'status');
                    const type = this.getPropertyValue(crew, 'type');
                    return getCrewStatusColor(status,'c-karta__bg-color--', type);
                } else {
                    return '';
                }
            },
            getCrewTypeList(type){
                const count = getPropertyValue(this.item, `vsk${type}`);
                console.log(this.item);
                const list = [];
                let id = 0;

                for(const crew of this.crews) {
                    let status = this.getPropertyValue(crew, 'status');

                    if (status === 'NA_PŘÍJMU') {
                        let currentVehicols = getPropertyValue(this.item, "posadky");
                        currentVehicols.splice(currentVehicols.indexOf(crew), 1);
                        try {
                            this.sendCommand({cmd: 'unassignCrewFromEvent', payload: {data: this.item, entityId: this.item.entityId, value: currentVehicols}});
                        } catch(e) {
                            console.log(e);
                        }
                    }

                    if(type === this.getPropertyValue(crew, 'type')){
                        list.push({
                            value: this.getPropertyValue(crew, 'volaciZnak'),
                            cssClass: this.getCrewColor(crew) + " c-karta__bg-color",
                            id: type + id++
                        });
                    }
                }

                /**
                 * Fill in (append) crews from history
                 */
                for(const crew of this.crewsHistory) {
                    const alreadyIncluded = (this.crews.filter(c => c.entityId === crew.entityId).length > 0);

                    if(!alreadyIncluded && type === this.getPropertyValue(crew, 'type')) {
                        let status = this.getPropertyValue(crew, 'status');
                                                
                        list.push({
                            value: this.getPropertyValue(crew, 'volaciZnak'),
                            cssClass: (status === 'NA_PŘÍJMU') ? (this.getCrewColor(crew) + " c-karta__bg-color") : ("c-karta__bg-color--s-history c-karta__bg-color"),
                            id: type + id++
                        });
                    }
                }

                /**
                 * Fill in expected (but missing, not assigned) crews
                 */
                for(let i = list.length; i < (count); i++) {
                    list.push({
                        value: type,
                        cssClass: this.getCrewColor(),
                        id: type + id++
                    });
                }

                return list;
            },
            getCrewCount() {
                return this.RZPs.concat(this.UMs,this.RVs,this.LZSs,this.KORs,this.IPs);
            },
            ...mapActions(['sendCommand']),
        },
        props:{
            item: Object
        },
        computed:{
            value(){
                return this.$props.item.entityId
            },
            isArchived(){
                return this.getPropertyValue(this.item, 'isArchived')
            },
            isAssigned(){
                return this.getPropertyValue(this.item, 'isAssigned')
            },
            isCancelled(){
                return this.getPropertyValue(this.item, 'isCancelled')
            },
            isForwarded(){
                return this.getPropertyValue(this.item, 'isForwarded')
            },
            canOpenEventModal(){
                return true
            },
            canStornoEvent(){  
                return !this.isArchived && !this.isCancelled && !this.isForwarded && !this.isAssigned
            },
            canForwardEvent(){
                return !this.isArchived && !this.isCancelled && !this.isForwarded && !this.isAssigned
            },
            canRevokeStornoEvent(){
                return this.isCancelled
            },
            canRevokeForwardEvent(){
                return this.isForwarded
            },
            canAddHospital(){
                return !this.isArchived && !this.isCancelled && !this.isForwarded
            },
            canShowOnMap(){
                return !this.isArchived && !this.isCancelled && !this.isForwarded
            },
            crews() {
                const entityIds = this.getPropertyValue(this.item, 'posadky') || [];
                return entityIds.map(entityId => this.$store.getters.getEntity(entityId));
            },
            crewsHistory(){
                const entityIds = this.getPropertyValue(this.item, 'posadkyHistory') || [];
                return entityIds.map(entityId => this.$store.getters.getEntity(entityId));
            },
            hospitals() {
                return this.$store.state.simulation.lists.hospitalList;
            },
            forwardEventTypes() {
                const forwardEventTypesList = this.$store.state.simulation.lists.forwardEventTypeList || [];
                return forwardEventTypesList.slice().sort((a, b) => getPropertyValue(a, 'order') - getPropertyValue(b, 'order'));
            },
            RZPs(){
                return this.getCrewTypeList('RZP');
            },
            UMs(){
                return this.getCrewTypeList('UM');
            },
            RVs(){
                return this.getCrewTypeList('RV');
            },
            LZSs(){
                return this.getCrewTypeList('LZS');
            },
            KORs(){
                return this.getCrewTypeList('KOR');
            },
            IPs(){
                return this.getCrewTypeList('IP');
            },
            timeLeft(){
                const timeLeft = this.$store.state.time.time-(getPropertyValue(this.item, 'casVznikuNum')||0);
                return moment.utc(timeLeft).format('H:mm:ss')
            }

        }
    }
</script>

<style lang="less" scoped>
    @import '~vue-context/dist/css/vue-context.css';

    .event-id {
        font-weight: bold;
        float: left;
        font-size: 1.2em;
        margin-right: -5px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        margin-top: 7px;
        color: #FFFFFF;
        border: thin solid white;
        padding: 5px 10px 5px 5px;
    }

    .c-context-a {
        position: relative;
        padding: .5rem 1.5rem;
        cursor: default;
        font-size: 11pt;
        line-height: 110%;
        &[href] {
            cursor: pointer;
        }
        &:hover {
            .c-context-wrap {
                display: block;
            }
        }
    }

    .c-context-wrap {
        width: 200px;
        position: absolute;
        bottom: 0;
        right: -200px;
        background-color: white;
        display: none;
    }

    .v-context__wrap .v-context {
        overflow-y: visible;
    }
    .c-context-wrap--2 {
        bottom: initial;
        top: 0;
    }
    .v-context {
        max-height: none;
        &--2 {
            bottom: initial;
            top: 0;
        }
    }

    .c-karta__table > tbody > tr > td {
        //color: #000; /* Fallback for older browsers */
        //color: rgba(1, 84, 124, 0.3);
        opacity: 0.15;

    }

</style>
